/*global window*/

var stickMrectEndPos = 0,
    stickyMrectStartPos,
    currentStickyMrect,
    scrollTimer;

const getWindowsTop = function() {
  return $(window).scrollTop();
};

const resetStickyMrect = function() {
  currentStickyMrect = '';
  stickyMrectStartPos = getWindowsTop();
  var pageBottomPosition = $('.srp-local-research').position();
  if (pageBottomPosition) {
    stickMrectEndPos = pageBottomPosition.top;
  }
};

const setCurrentStickMrect = function(newStickMrect) {
  let stickyMrect = [];
  if (newStickMrect > currentStickyMrect) {
    currentStickyMrect = newStickMrect;
    window.gptAds.gptadslotsSrpStickyMrect.targets.forEach(function(element) {
      if (element && element.getSlotElementId() === currentStickyMrect) {
        stickyMrect.push(element);
      }
    });
    $('.srp-sticky-ad').hide();
    $('#' + currentStickyMrect).parent().show();
  }
  return stickyMrect;
};

const withinStickyRang = function(currentWindowTop) {
  return currentWindowTop >= stickyMrectStartPos && (stickMrectEndPos === 0 || currentWindowTop <= stickMrectEndPos);
};

const getNewStickMrect = function(currentWindowTop) {
  let newStickMrect = '';
  if (currentWindowTop < stickyMrectStartPos+1300) {
    newStickMrect = 'div-gpt-ad-MRECTSTICKY_1';
  }
  else if (currentWindowTop < stickyMrectStartPos+2400) {
    newStickMrect = 'div-gpt-ad-MRECTSTICKY_2';
  }
  else if (currentWindowTop < stickyMrectStartPos+3500) {
    newStickMrect = 'div-gpt-ad-MRECTSTICKY_3';
  }
  else {
    newStickMrect = 'div-gpt-ad-MRECTSTICKY_4';
  }
  return newStickMrect;
};

const getCurrentStickMrect = function() {
  let currentWindowTop = getWindowsTop();
  if (withinStickyRang(currentWindowTop)) {
    let newStickMrect = getNewStickMrect(currentWindowTop);
    return setCurrentStickMrect(newStickMrect);
  }
  return [];
};

const stickyAdScroller = function(stickyMrect, loadProgrammaticAds) {
  if (scrollTimer) {
    clearTimeout(scrollTimer);
  }
  scrollTimer = setTimeout(function() {
    loadProgrammaticAds(stickyMrect);
  }, 250);
};

const onScroll = function(getViewType, loadProgrammaticAds) {
  if (getViewType() === "list") {
    var stickyMrect = getCurrentStickMrect();
    if (stickyMrect.length > 0) {
      stickyAdScroller(stickyMrect, loadProgrammaticAds);
    }
  }
};

export const SrpOnScroll = onScroll;
export const SrpCurrentStickMrect = getCurrentStickMrect;
export const SrpResetStickyMrect = resetStickyMrect;



// WEBPACK FOOTER //
// ./shared_critical/media/srp_sticky.js